import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { SharedItemPriority } from "@/Common/Models/Portal/SharedItem/SharedItemPriority";
import { IPortalLinkedItemModel } from "@/Common/Models/Portal/UI/IPortalLinkedItemModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { BaseSendToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendToPortalPopupStrategy";

class SendResultStrategy extends BaseSendToPortalPopupStrategy {
    public readonly disclaimer = "";
    public readonly itemCheckOperation: number = LocalOperations.LabsUI.OnPortalLabItemChecked;

    constructor() {
        super(
            PortalLinkedItemType.Result,
            LocalOperations.LabsUI.PortalStatusRevoked,
            LocalOperations.LabsUI.CloseSendToPortalPopup
        );
    }

    public onSendToPortalClick(subject: string, newMessage: string, includeDocument: boolean, _portalItemModel?: IPortalLinkedItemModel, priority?: SharedItemPriority, canPatientReplyWithMessage?: boolean): void {
        sessionStore.dispatch(
            LocalOperations.LabsUI.PortalStatusSend,
            {
                subject: subject,
                messageText: newMessage,
                includeDocument: includeDocument,
                priority: priority,
                canPatientReplyWithMessage: canPatientReplyWithMessage
            }
        );
    }
}

export { SendResultStrategy };
